export default __webpack_public_path__ + "static/media/insta.79dd1c0e.svg";